export default __webpack_public_path__ + "static/media/TestGroupHealthPlanBranding.850b6157.png";